'use strict';

const _ = require('underscore');
const Moment = require('moment');
const Tooltip = require('common/ui/view/behavior/tooltip');
const ProjectCreateView = require('balus/ui/view/body/group/nav/project-create');
const ProjectItemViewTemplate = require('balus/ui/template/body/group/nav/project-item.hbs');
const ProjectListViewTemplate = require('balus/ui/template/body/group/nav/project-list.hbs');
const ProjectItemContentTemplate = require('balus/ui/template/body/group/nav/project-item-content.hbs');
const GroupPermission = require('common/domain/entity/group-permission');
const NoProjectTemplate = require('balus/ui/template/body/group/nav/no-project.hbs');
const ReadMoreTemplate = require('balus/ui/template/body/group/nav/project-readmore.hbs');
const ModalView = require('common/ui/view/modal/index');
const i18n = require('i18next');
const Mn = require('backbone.marionette');

const ProjectItemContentView = Mn.View.extend({
    template: ProjectItemContentTemplate,
    behaviors: [Tooltip],

    modelEvents: {
        'change': 'render'
    },

    templateContext: function() {
        const today = Moment();
        const startAt = this.model.getStartAt();
        const endAt = this.model.getEndAt();
        const startLastDays = Moment(startAt).diff(today, 'days');
        const endLastDays = Moment(endAt).diff(today, 'days');
        const isActive = !(this.model.getStateType() === 'final' || this.model.getStateType() === 'terminated');
        const isInitial = this.model.getStateType() === 'initial';
        const startIsDelayed = isInitial && startLastDays < 0;
        const endIsDelayed = isActive && endLastDays < 0;
        const isDelayed = startIsDelayed || endIsDelayed;

        const hasDelayedActions = this.model.hasDelayedActions();

        const members = this.getSortedAssignees();
        const dispMembersNum = 5;
        const dispMembers = members.slice(0, dispMembersNum);

        return {
            link: this.model.path(),
            updatedAt: this.model.getUpdatedAt(),
            stateName: this.model.getStateName(),
            stateType: this.model.getStateType(),
            isActive: isActive,
            isInitial: isInitial,
            startAt: startAt,
            endAt: endAt,
            startIsDelayed: startIsDelayed,
            startDelay: {
                lastDays: startLastDays,
                delayedDays: -startLastDays,
            },
            endIsDelayed: endIsDelayed,
            endDelay: {
                lastDays: endLastDays,
                delayedDays: -endLastDays,
            },
            isDelayed: isDelayed,
            hasDelayedActions: hasDelayedActions,
            hasWarning: isDelayed || hasDelayedActions,
            dispMembers: dispMembers.length > 0 ? dispMembers : null,
            moreMembersNum: members.length > dispMembersNum ? members.length - dispMembersNum : null,
        }
    },

    getSortedAssignees: function() {
        const user = this.getOption('context').getUser();
        const members = this.model.getMembers().clone();

        // ログイン中ユーザがメンバーになっている場合には、先頭に追加しなおす
        const currentUserMember = members.getMemberByUser(user.id);
        if (currentUserMember) {
            members.remove(currentUserMember);
            members.add(currentUserMember, {at: 0});
        }

        return _.map(members.models, member => {
            return member.attributes;
        });
    },
});

const ProjectItemView = Mn.View.extend({
    tagName: 'li',
    className: 'list-item',
    template: ProjectItemViewTemplate,
    regions: {
        content: '.project-item-content-wrapper'
    },

    onRender: function() {
        this.showChildView('content', new ProjectItemContentView({
            model: this.model,
            context: this.getOption('context')
        }));
    }
});

const ReadMoreView = Mn.View.extend({
    tagName: 'div',
    template: ReadMoreTemplate,
    events: {
        'click': 'more'
    },

    initialize(options) {
        ReadMoreView.__super__.initialize.call(options);

        this.listenTo(this.collection, 'change:paginate', this.render);
    },

    templateContext: function() {
        return {
            hasMore: this.collection.hasMore()
        };
    },

    more: function() {
        this.collection.fetchMore(10);
    }
});

const NoProjectView = Mn.View.extend({
    template: NoProjectTemplate
});

const ProjectListView = Mn.CollectionView.extend({
    emptyView: NoProjectView,
    childView: ProjectItemView,
    childViewContainer: '.project-list',
    childViewOptions: function() {
        return {
            context: this.getOption('context')
        };
    },
});

module.exports = Mn.View.extend({
    template: ProjectListViewTemplate,
    regions: {
        projectList: '.project-list',
        projectListReadMore: '.project-list-readmore'
    },
    ui: {
        'addProjectButton': '.project-add-button'
    },
    events: {
        'click @ui.addProjectButton': 'addProject'
    },
    templateContext: function() {
        const context = this.getOption('context');
        const groupRole = context.getGroupRole();
        return {
            canAddProject: groupRole.getPermission(GroupPermission.ProjectCreatePermission).isPermitted(context)
        };
    },

    onRender: function() {
        this.showChildView('projectList', new ProjectListView({
            model: this.model,
            collection: this.collection,
            context: this.getOption('context')
        }));

        this.showChildView('projectListReadMore', new ReadMoreView({
            collection: this.collection
        }));
    },

    addProject: function() {
        const modal = new ModalView({
            title: i18n.t('balus_template_body_group:nav.project-create.title'),
            bodyView: new ProjectCreateView({
                group: this.model,
                collection: this.collection
            }),
            onChildviewSave: function() {
                this.disableButtons();
                this.getOption('bodyView').setting()
                    .then(() => {
                        // プロジェクト作成した後に、プロジェクト一覧に表示するための ProjectStatus が作成され、
                        // firebase realtime database 経由でブラウザに同期されるまで少し時間がかかる。
                        // 編集モーダルを閉じるまでの時間を取ることで、体感の遅延時間を軽減する。
                        _.delay(() => {
                            this.hide();
                        }, 1000);
                    })
                    .catch(() => {
                        this.enableButtons();
                    });
            }
        });
        modal.show();
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/group/nav/project-list.js